import type {
  GeneratedPacketData,
  TerminatedPacketData,
} from '@ipfabric/utils';

export const isGeneratedPacketData = (
  packetData: GeneratedPacketData | TerminatedPacketData,
): packetData is GeneratedPacketData => 'severityInfo' in packetData;
